import apiConfig from 'config/apiConfig'

const makeRequest = async (method: string, url: string, data?: any) => {
  try {
    const response = await apiConfig.request({
      method,
      url,
      data,
    })

    return response.data
  } catch (error) {
    console.error('API ERROR: ', error)
  }
}

export default makeRequest
